module.exports = __webpack_public_path__ + "img/gui_00_landing_1_bg.e6d2c0da.jpg";